import { render, staticRenderFns } from "./uploading-img.vue?vue&type=template&id=3954f2b0&scoped=true"
import script from "./uploading-img.vue?vue&type=script&lang=js"
export * from "./uploading-img.vue?vue&type=script&lang=js"
import style0 from "./uploading-img.vue?vue&type=style&index=0&id=3954f2b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3954f2b0",
  null
  
)

export default component.exports